import axios from "axios";
import { GET, POST } from '../_helpers/Fetch';
import { UrlFilterHelper } from "../_helpers/UrlFilterHelper";
import { SubscriptionApiUrl } from '../_constants/SubscriptionAPI';

export const SubscriptionApi = {
    getProductList,
    GetBillingLines, UpdateBillingLine,
    GetProductSubscriptionPricing,
    GetSelectedProductSubscriptions,
    RequireBaseSubscription,
    GetFutureSubscription: GetFutureVstsSubscription,
    PlaceOrder,
    UserGetOrganizationProductSubcriptionList,
    AdminOrganizationGetOrganizationProductSubcriptionList,
    AdminExportAllOrganizationProductSubcriptions,
    CheckProductSubscriptionExist,
    GetSubscription,
    CancelSubscription,
    GetFeeWaiver,
    GetFeeWaiverOptions,
    GetCurrentVstsActiveSubscription: GetLatestNonFutureVstsSubscription,
    UpdateVstsSubscriptionDates,
    GetCurrentActiveSubscription
};

function getProductList() {
    return axios.get(SubscriptionApiUrl.PRODUCT_BASEURL + "getlist");
}

async function GetBillingLines(type) {
    try {
        const { data: Response } = await GET(SubscriptionApiUrl.BILLING_LINES_LIST + type);
        return Response; // Returns: PagedResultDto<BillingLineDto>
    } catch (err) {
        return null;
    }
}

async function UpdateBillingLine(id, billingLineDto) {
    try {
        const { data: Response } = await POST(SubscriptionApiUrl.BILLING_LINES_UPDATE + id, billingLineDto);
        return Response; // Returns: BillingLineDto
    } catch (err) {
        return null;
    }
}

async function GetProductSubscriptionPricing(productId, infoId) {
    try {
        var url = SubscriptionApiUrl.STORE_GETPRICING;
        url = url.replace("{0}", productId);
        url = url.replace("{1}", infoId);

        const { data: ProductPriceMapping } = await GET(url);
        return ProductPriceMapping; // Returns: ProductPriceMappingDto
    } catch (err) {
        return null;
    }
}

async function GetSelectedProductSubscriptions(productIds) {
    try {
        var url = SubscriptionApiUrl.STORE_GETSELECTED_PRODUCT_SUBSCRIPTIONS;
        productIds.forEach((id) => {
            url += "productIds=" + id + "&"
        })

        const { data: selectedProductSubscriptions } = await GET(url);
        return selectedProductSubscriptions; // Returns a mapped entry of Product Ids to their available subscriptions
    } catch (err) {
        return null;
    }
}

async function RequireBaseSubscription() {
    try {
        var url = SubscriptionApiUrl.STORE_REQUIRE_BASE_SUBSCRIPTION;

        const { data: requireBaseExtensionCheck } = await GET(url);
        return requireBaseExtensionCheck; // Returns a mapped entry of Product Ids to their available subscriptions
    } catch (err) {
        return null;
    }
}

async function GetFutureVstsSubscription() {
    try {
        var url = SubscriptionApiUrl.STORE_GET_FUTURE_VSTS_SUBSCRIPTION;
        const { data: futureSubscription } = await GET(url);
        return futureSubscription;
    } catch (err) {
        return null;
    }
}

async function GetCurrentActiveSubscription() {
    try {
        var url = SubscriptionApiUrl.STORE_GET_ACTIVE_VSTS_SUBSCRIPTION;
        const { data: currentSubscription } = await GET(url);
        return currentSubscription;
    } catch (err) {
        return null;
    }
}

async function GetLatestNonFutureVstsSubscription() {
    try {
        var url = SubscriptionApiUrl.ORGANIZATION_PRODUCT_SUBSCRIPTION_GET_LATEST_NON_FUTURE_SUBSCRIPTION;
        const { data: currentSubscription } = await GET(url);
        return currentSubscription;
    } catch (err) {
        return null;
    }
}

async function UpdateVstsSubscriptionDates(subscriptionDto) {
    try {
        var url = SubscriptionApiUrl.ORGANIZATION_PRODUCT_SUBSCRIPTION_UPDATE_VSTS_SUBSCRIPTION_DATES;
        return axios.post(url, subscriptionDto);
    } catch (err) {
        return null
    }
}

async function PlaceOrder(organizationId, orderList) {
    try {
        var url = SubscriptionApiUrl.STORE_PLACE_ORDER;
        url = url.replace("{0}", organizationId);

        console.log('PlaceOrder - order information:', orderList);
        const { data: orderDto } = await POST(url, orderList);
        return orderDto; // Returns a mapped entry of Product Ids to their available subscriptions
    } catch (err) {
        return null;
    }
}

async function UserGetOrganizationProductSubcriptionList(skipCount, sorting, dsc, filter) {
    var url = UrlFilterHelper.GetFilterdUrl(SubscriptionApiUrl.ORGANIZATION_GET_ORGANIZATION_PRODUCT_SUBSCRIPTION_LSIT, skipCount, filter.search, sorting, dsc);
    if (filter.subscriptionStatus != null) {
        url += "&subscriptionStatus=" + filter.subscriptionStatus;
    }
    return axios.get(url); // Returns: PagedResultDto<OrganizationProductSubscriptionSearchDto>
}

async function AdminOrganizationGetOrganizationProductSubcriptionList(skipCount, sorting, dsc, filter, search) {
    var url = UrlFilterHelper.GetFilterdUrl(SubscriptionApiUrl.ADMIN_ORGANIZATION_GET_ORGANIZATION_PRODUCT_SUBSCRIPTION_LSIT, skipCount, search, sorting, dsc);
    if (filter.subscriptionStatus != null) {
        url += "&subscriptionStatus=" + filter.subscriptionStatus;
    }
    if (filter.bid != null) {
        url += "&bid=" + filter.bid;
    }        
    return axios.get(url); // Returns: PagedResultDto<OrganizationProductSubscriptionSearchDto>
}

async function AdminExportAllOrganizationProductSubcriptions() {
    return axios.get(SubscriptionApiUrl.ADMIN_ORGANIZATION_EXPORT_ALL_ORGANIZATION_PRODUCT_SUBSCRIPTION, {
        responseType: "blob",
    });
}

async function CheckProductSubscriptionExist(productIds) {
    try {
        var url = SubscriptionApiUrl.STORE_CHECK_VSTT_SUBSCRIPTION_EXIST + "?";
        productIds.forEach((id) => {
            url += "productIds=" + id + "&"
        })

        const { data: existingProductSubscriptions } = await GET(url);
        return existingProductSubscriptions;
    } catch (err) {
        return null;
    }
}

function GetSubscription(id) {
    return axios.get(SubscriptionApiUrl.ORGANIZATION_PRODUCT_SUBSCRIPTION_GET + id); // Returns: OrganizationProductSubscriptionDto
}

function CancelSubscription(cancelSubscriptionDto) {
    return axios.post(SubscriptionApiUrl.ORGANIZATION_PRODUCT_SUBSCRIPTION_CANCEL + cancelSubscriptionDto.id, cancelSubscriptionDto); // Returns: ApiResponse<OrganizationProductSubscriptionDto>
}


function GetFeeWaiver() {
    return axios.get(SubscriptionApiUrl.FEE_WAIVER_GET); // Returns: PagedResultDto<FeeWaiverDto>
}

async function GetFeeWaiverOptions(productSubscriptionIds) {
    try {
        var url = SubscriptionApiUrl.FEE_WAIVER_OPTIONS + "?";
        productSubscriptionIds.forEach((id) => {
            url += "productSubscriptionIds=" + id + "&"
        })

        const { data: requireBaseExtensionCheck } = await GET(url);
        return requireBaseExtensionCheck; // Returns a mapped entry of Product Ids to their available subscriptions
    } catch (err) {
        return null;
    }
}